import React from "react";
import * as styles from "./styles/HomeLiveInstructionCallout.css";

const HomeLiveInstructionCallout = () => {
	return (
		<div>
			<div className={styles.waveTop}>
				<img
					src="/assets/images/vc/wave/blue/top.svg"
					alt=""
					width="1440"
					height="163"
				/>
			</div>

			<div className={styles.wrap}>
				<div className={styles.card}>
					<div className={styles.img}>
						<img
							srcSet="/assets/images/vc/student.png 274w, /assets/images/vc/student-dt.png 764w"
							sizes="(max-width: 767px) 274px, 764px"
							src="/assets/images/vc/student-dt.png"
							alt="student actively engaged in a virtual classroom with beast academy characters"
						/>
					</div>

					<div className={styles.cta}>
						<h2>Prefer a Live Instructor?</h2>

						<p>
							Does your student prefer face-to-face interaction? Our virtual
							campus combines Beast Academy curriculum with a live, video-based
							classroom. Students are guided by expert instructors and learn
							alongside 10–16 curious peers.
						</p>

						<a className={styles.btn} href="/live-classes">
							ENROLL NOW
						</a>
					</div>
				</div>
			</div>

			<div className={styles.wave}>
				<img
					src="/assets/images/vc/wave/blue/bot.svg"
					alt="blue wave bottom"
					width="1440"
					height="198"
				/>
			</div>
		</div>
	);
};

export default HomeLiveInstructionCallout;
